import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { CommonpageLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const UserLogin = lazy(() => import("./UserLogin"));
const Register = lazy(() => import("./RegisterPage"));
const Auth = lazy(() => import("./AuthPage"));

export function getAuthRoutes() {
  return [
    { path: "/", layout: CommonpageLayout, element: <Navigate to="/login" replace /> },
    { path: "/login", layout: CommonpageLayout, element: withSuspense(UserLogin) },
    { path: "/register", layout: CommonpageLayout, element: withSuspense(Register) },
    { path: "/auth", layout: CommonpageLayout, element: withSuspense(Auth) },
    { path: "*", layout: CommonpageLayout, element: <Navigate to="/login" replace /> },
  ];
}
